import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './SubmissionReview.css';

function SubmissionReview() {
    const { id } = useParams();
    const [submissionDetails, setSubmissionDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSubmissionReview = async () => {
            try {
                const response = await fetch(`/get_submission_review/${id}`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setSubmissionDetails(data);
            } catch (error) {
                setError(error.message);
            } finally {
                setIsLoading(false);
            }
        };

        fetchSubmissionReview();
    }, [id]);

    if (isLoading) return <div className="message">Loading submission details...</div>;
    if (error) return <div className="message">Error fetching submission. Please try again later.</div>;
    if (!submissionDetails) return <div className="message">No submission details available.</div>;

    return (
        <div className="submission-review-container">
            <div className="question-header">
                <h1 className="question-title">{`Question ${submissionDetails.question_id}: ${submissionDetails.question}`}</h1>
            </div>
            <div className="answer-input-container">
                <textarea
                    readOnly
                    value={submissionDetails.answer}
                    className="answer-input"  // Add this line
                />
            </div>

            {/* Feedback Section */}
            <div className="feedback-container">
                <div className="feedback-score">
                    <span className="feedback-message">{submissionDetails.short_feedback}</span>
                    <div className="score-circle">{submissionDetails.score}</div>
                </div>
                <div className="feedback-text">
                    <strong>Feedback:</strong>
                    <p>{submissionDetails.feedback}</p>
                </div>
                <div className="enhanced-response">
                    <strong>Enhanced Response:</strong>
                    {submissionDetails.enhanced_response ? (
                        <p>{submissionDetails.enhanced_response}</p>
                    ) : (
                        <p className="locked-response">🔒</p>
                    )}
                </div>
            </div>
        </div>
    );
}
export default SubmissionReview;
